import { isNativeApp } from "./platform";

/** Long-press menu on the home-screen icon. iOS shows `description` only with an icon. */
export interface AppShortcutItem {
  readonly id: string;
  readonly title: string;
  readonly description: string;
  /** SF Symbol name. */
  readonly iosIcon: string;
}

/** Native only: replace the icon's quick actions. Best-effort. */
export async function setAppShortcuts(
  items: readonly AppShortcutItem[],
): Promise<void> {
  if (!isNativeApp()) return;
  try {
    const { AppShortcuts } = await import(
      "@capawesome/capacitor-app-shortcuts"
    );
    await AppShortcuts.set({ shortcuts: items.map((item) => ({ ...item })) });
  } catch {
    // Launcher without shortcut support: the icon simply has no menu.
  }
}

/** Native only: fires with the shortcut id, also for the one that cold-started the app. */
export async function onAppShortcut(
  handler: (id: string) => void,
): Promise<() => void> {
  if (!isNativeApp()) return () => {};
  try {
    const { AppShortcuts } = await import(
      "@capawesome/capacitor-app-shortcuts"
    );
    const handle = await AppShortcuts.addListener("click", (event) => {
      handler(event.shortcutId);
    });
    return () => {
      void handle.remove();
    };
  } catch {
    return () => {};
  }
}
